import React from 'react';
import ReactDOM from 'react-dom';

import './assets/css/style.css';
import './assets/css/footer.css';
import './assets/css/login_media_queries.css';
import './assets/css/main.css';
import './assets/css/frogger.css';
import './assets/css/login.css';
import './assets/css/header.css';
import './assets/css/forgotPassword.css';
import './assets/css/forgot_media_query.css';
import './assets/css/registration.css';
import './assets/css/registration_media_queries.css';
import './assets/css/upload.css';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import Routes from './components/routes';

ReactDOM.render(<Routes />, document.getElementById('root'));
